import { fetchClient } from "@/api/api";
import type { getStatusInput, getStatusOutput } from "@/api/custom_types";
import type { CustomQueryHook } from "@/utils/react-query";
import { useQuery } from "@tanstack/react-query";
import { STATUS_SERVICE_KEYS } from "./keys";

export const useGetStatus: CustomQueryHook<getStatusOutput, getStatusInput> = (
	options?,
) => {
	return useQuery({
		...options,
		queryKey: STATUS_SERVICE_KEYS.useGetStatus(),
		queryFn: async () => {
			const { data, error } = await fetchClient.GET("/v1/fc/status/", {
				throwOnError: true,
			});

			if (error) throw error;
			return data;
		},
		staleTime: 1 * 60 * 60 * 1_000, // 1 hour
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		retry: 3,
	});
};
